import Swiper from "swiper";
import { A11y } from "swiper/modules";

export default function () {
    const root = document.querySelector(
        '.o-highlights-cards__swiper[data-swiper="highlights-cards"]',
    );
    if (!root) return;

    return new Swiper(root, {
        modules: [A11y],
        slidesPerView: 1,
        spaceBetween: 16,
        a11y: true,
        autoHeight: false,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        },
    });
}
